import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useCaptureDL38299 } from "../../../hooks/Capture";
import CaptureDL38299 from "../DL38299/CaptureDL38299";

interface DL38299TabProps {
  captureId: string;
  handleError: (error: any) => void;
  canEdit: boolean;
}

const DL38299Tab: React.FC<DL38299TabProps> = ({ captureId, handleError, canEdit }) => {
  const { DL38299Data, isPending, createDL38299, updateDL38299 } = useCaptureDL38299(captureId);

  if (isPending && DL38299Data === null) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <CaptureDL38299
      DL38299Data={DL38299Data}
      canEdit={canEdit}
      onCreate={async (values) => {
        await createDL38299(values).catch(handleError);
      }}
      onUpdate={async (id, values) => {
        await updateDL38299({ dlId: id, values }).catch(handleError);
      }}
    />
  );
};

export default DL38299Tab;
